import React, { useState, useEffect } from "react";

import { NotificationManager } from "react-notifications";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";

import { sessionActions } from "./store";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import PersonIcon from "@material-ui/icons/PermIdentity";
import LockIcon from "@material-ui/icons/Lock";
import Button from "@material-ui/core/Button";

import styles from "../styles/login.module.css";
import { useNavigate } from "react-router-dom";
import Conf from "../conf";

const Login = () => {
    const dispatch = useDispatch();
    const history = useNavigate();

    const [username, setUsername] = useState(localStorage.getItem("user"));
    const [password, setPassword] = useState("");

    let wait = false;

    useEffect(() => {
        fetch(`${Conf.server_address}/session`, { method: "GET", credentials: "include" }).then((response) => {
            if (response.status === 200) {
                response.json().then((Json) => {
                    dispatch(sessionActions.updateUser(Json));
                    history("/map");
                });
            }
        });
    }, [dispatch, history]);

    const handleLogin = () => {
        if (wait) {
            NotificationManager.warning("لطفا منتظر باشید", "", 2500);
        } else if (username === "") {
            wait = false;
            NotificationManager.error("لطفا نام کاربری را وارد کنید", "", 2500);
        } else if (password === "") {
            wait = false;
            NotificationManager.error("لطفا گذرواژه را وارد کنید", "", 2500);
        } else {
            wait = true;

            var formData = new URLSearchParams();
            formData.append("email", username);
            formData.append("password", password);

            fetch(`${Conf.server_address}/session`, {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                credentials: "include",
                body: formData,
            })
                .then((response) => {
                    return response.status === 200 ? response.json() : { error: response.status };
                })
                .then((response) => {
                    wait = false;
                    if (response.error) {
                        NotificationManager.error("نام کاربری یا رمز عبور معتبر نیست ", "", 2500);
                    } else {
                        dispatch(sessionActions.updateUser(response));
                        history("/map");
                    }
                })
                .catch(() => {
                    wait = false;
                    NotificationManager.error("خطای شبکه", "", 2500);
                });
        }
    };

    return (
        <div className={styles.main}>
            {!isMobile ? <div className={styles.background}></div> : []}

            <div className={isMobile ? styles.mobilePaper : styles.paper}>
                <div className={isMobile ? styles.mobileLogo : styles.logo}></div>
                <h1 className={styles.h1}>ورود</h1>
                <form className={styles.form}>
                    <Paper component="div" className={styles.inputHolder}>
                        <InputBase
                            value={username}
                            onChange={(event) => {
                                localStorage.setItem("user", event.target.value);
                                setUsername(event.target.value);
                            }}
                            className={styles.input}
                            placeholder="نام کاربری"
                            inputProps={{ "aria-label": "نام کاربری" }}
                            style={{ textAlign: "right", direction: "rtl", paddingRight: "10px" }}
                        />
                        <PersonIcon className={styles.icon} />
                    </Paper>

                    <Paper component="div" className={styles.inputHolder}>
                        <InputBase
                            value={password}
                            onChange={(event) => {
                                setPassword(event.target.value);
                            }}
                            className={styles.input}
                            placeholder="گذرواژه"
                            inputProps={{ "aria-label": "گذرواژه" }}
                            type={"password"}
                            style={{ textAlign: "right", direction: "rtl", paddingRight: "10px" }}
                        />
                        <LockIcon className={styles.icon} />
                    </Paper>

                    <Button style={{ backgroundColor: "#263C99", width: "72%", color: "#fff", fontFamily: "YekanBakh" }} variant="contained" onClick={() => handleLogin()}>
                        ورود
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default Login;
